export default "__VITE_ASSET__20ae6e27__"